import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { MatTabsModule } from '@angular/material';

import { AuthGuardService, UserService } from '@core/services';
import { User } from '@shared/models';

import { fadeAnimation } from '../../app.animations';

@Component({
    selector: 'app-manage-profile',
    templateUrl: './manage-profile.component.html',
    styleUrls: ['./manage-profile.component.css'],
    animations: [fadeAnimation]
})
export class ManageProfileComponent implements OnInit, OnDestroy {

    tab: number;
    subscription: Subscription;
  userSubscription: Subscription;
  user:  User;

  constructor(private route: ActivatedRoute, private _userService: UserService, private mdTabsModule: MatTabsModule) { }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            let path = params['tab'];
            if (path == 'mailing') {
                this.tab = 0;
            } else if (path == 'billing') {
                this.tab = 1;
            }
            else if (path == 'credit') {
                this.tab = 2;
            }
        });

    this.userSubscription = this._userService.getUser().subscribe(user => {
      this.user = user;
    });

    }

  ngOnDestroy(){
    this.subscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/manage-profile/manage-profile.component.ts